import { AboutYourLoan, defaultAboutYourLoan } from "domain/aboutYourLoan";
import { action, makeObservable } from "mobx";
import { StoreBase } from "./storeBase";

export class AboutYourLoanStore extends StoreBase<{}> {
  constructor() {
    super(() => defaultAboutYourLoan());
    makeObservable(this);
  }

  data: AboutYourLoan = defaultAboutYourLoan();

  @action storeAboutYourLoan(aboutLoan: AboutYourLoan) {
    this.data = aboutLoan;
  }
}
